import type { RegionCode, RegionGoteborg, RegionMalmo, RegionOrebro, RegionStockholm } from '@sortera/dvfv-types'
import type { CompanyCode } from '@sortera/dvfv-types'
import {
  AKERISACKEN,
  BIG_BAG,
  SORTERA_GOTEBORG,
  SORTERA_MALMO,
  SORTERA_OREBRO,
  SORTERA_STOCKHOLM,
} from '@sortera/dvfv-types'
import type { AssertArrayCoversUnion } from '@sortera/ee-utils'

export const STOCKHOLM: RegionStockholm = 'stockholm' as const
export const GOTEBORG: RegionGoteborg = 'goteborg' as const
export const MALMO: RegionMalmo = 'malmo' as const
export const OREBRO: RegionOrebro = 'orebro' as const
const ALL_REGIONS = [STOCKHOLM, GOTEBORG, MALMO, OREBRO] as const

export interface Position {
  lat: number
  lng: number
}

export interface Region {
  id: number
  code: RegionCode
  name: string
  companies: CompanyCode[]
}

/**
 * Returns all companies whose orders are handled in a region.
 */
export function regionToCompanies(region: RegionCode): CompanyCode[] {
  return REGIONS.find(r => r.code === region)?.companies ?? []
}

/**
 * Returns the center position of a given region.
 */
export function regionCenterPosition(region: RegionCode): Position {
  switch (region) {
    case GOTEBORG:
      return {
        lat: 57.70887,
        lng: 11.97456,
      }

    case MALMO:
      return {
        lat: 55.60587,
        lng: 13.00073,
      }

    case OREBRO:
      return {
        lat: 59.27516,
        lng: 15.21271,
      }

    case STOCKHOLM:
    default:
      return {
        lat: 59.334591,
        lng: 18.06324,
      }
  }
}

export const REGIONS: Region[] = [
  {
    id: 1,
    code: STOCKHOLM,
    name: 'Stockholm',
    companies: [SORTERA_STOCKHOLM, BIG_BAG, AKERISACKEN],
  },
  { id: 2, code: GOTEBORG, name: 'Göteborg', companies: [SORTERA_GOTEBORG] },
  { id: 3, code: MALMO, name: 'Malmö', companies: [SORTERA_MALMO] },
  { id: 4, code: OREBRO, name: 'Örebro', companies: [SORTERA_OREBRO] },
]

export function stringToRegionCode(value: string): RegionCode {
  if (!stringIsRegionCode(value)) {
    throw new Error(`${value} is not a valid RegionCode`)
  }
  return value
}

function stringIsRegionCode(value: string): value is RegionCode {
  const _: AssertArrayCoversUnion<RegionCode, typeof ALL_REGIONS> = true
  return ALL_REGIONS.some(region => region === value)
}
